import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { exportTopAchieversReport, getType } from "../../actions/studensts";
import UNAUTHORIZED from "../UNAUTHORIZED";
import StudentList from "../StudentList";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

export default function Invoice() {
  const dispatch = useDispatch();
  const location = useLocation();
  const studentType = useLocation().pathname.split("/")[3];
  const { students } = useSelector((state) => state.students);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);
  const count = useSelector((state) => state.students.count);
  const user = JSON.parse(localStorage.getItem("profile")).value[0].role;

  useEffect(() => {
    dispatch({ type: "CLEAR" });
    if (!hasSearched) return;
    const state = convertType(studentType);
    const timeOutId = setTimeout(
      () => dispatch(getType("invoice", state, search)),
      500
    );
    return () => clearTimeout(timeOutId);
  }, [location, search, dispatch, studentType, hasSearched]);

  useEffect(() => {
    setHasSearched(false);
  }, [location]);

  useEffect(() => {
    if (students) {
      setLoading(false);
    } else {
      setLoading(true);
    }
  }, [students]);

  const handleExportTopAchievers = async () => {
    try {
      const { data } = await exportTopAchieversReport();
      const topAchievers = data?.data || [];

      const workbook = new ExcelJS.Workbook();
      workbook.creator = "AATC System";
      workbook.created = new Date();
      const sheet = workbook.addWorksheet("Top Achievers");

      sheet.mergeCells("A1:D1");
      const titleCell = sheet.getCell("A1");
      titleCell.value = "Top Achievers Students Report";
      titleCell.font = {
        name: "Arial",
        size: 16,
        bold: true,
        color: { argb: "FFFFFFFF" },
      };
      titleCell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FF1F4E79" },
      };
      titleCell.alignment = { horizontal: "center", vertical: "middle" };
      sheet.getRow(1).height = 35;

      sheet.mergeCells("A2:D2");
      const countCell = sheet.getCell("A2");
      countCell.value = `Total Students: ${topAchievers.length}`;
      countCell.font = {
        name: "Arial",
        size: 13,
        bold: true,
        color: { argb: "FF1F4E79" },
      };
      countCell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFD6E4F0" },
      };
      countCell.alignment = { horizontal: "center", vertical: "middle" };
      sheet.getRow(2).height = 28;

      sheet.getRow(3).height = 8;

      const headers = ["Full Name", "National ID", "Phone Number", "Email"];
      const headerRow = sheet.getRow(4);
      headerRow.values = headers;
      headerRow.height = 26;
      headerRow.eachCell((cell) => {
        cell.font = {
          name: "Arial",
          size: 11,
          bold: true,
          color: { argb: "FFFFFFFF" },
        };
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FF2E75B6" },
        };
        cell.alignment = {
          horizontal: "center",
          vertical: "middle",
          wrapText: true,
        };
        cell.border = {
          top: { style: "thin", color: { argb: "FF1F4E79" } },
          bottom: { style: "thin", color: { argb: "FF1F4E79" } },
          left: { style: "thin", color: { argb: "FF1F4E79" } },
          right: { style: "thin", color: { argb: "FF1F4E79" } },
        };
      });

      topAchievers.forEach((s, idx) => {
        const row = sheet.getRow(5 + idx);
        row.values = [
          s.full_name || "",
          s.national_id || "",
          s.phone || "",
          s.email || "",
        ];
        const isEven = idx % 2 === 0;
        row.eachCell((cell) => {
          cell.font = { name: "Arial", size: 10 };
          cell.alignment = {
            horizontal: "center",
            vertical: "middle",
            wrapText: true,
          };
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: isEven ? "FFF2F7FB" : "FFFFFFFF" },
          };
          cell.border = {
            top: { style: "thin", color: { argb: "FFB4C6E7" } },
            bottom: { style: "thin", color: { argb: "FFB4C6E7" } },
            left: { style: "thin", color: { argb: "FFB4C6E7" } },
            right: { style: "thin", color: { argb: "FFB4C6E7" } },
          };
        });
      });

      sheet.columns = [
        { width: 30 },
        { width: 20 },
        { width: 18 },
        { width: 35 },
      ];

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, "top_achievers_report.xlsx");
    } catch (error) {
      console.error("Export to Excel failed:", error);
    }
  };

  return (
    <div>
      {user !== "user" && user !== "invoice" && user !== "admin" ? (
        <UNAUTHORIZED />
      ) : (
        <div>
          <div className="flex flex-wrap pt-0 pl-6 pb-5 justify-between">
            <h1 className="text-2xl text-white">
              {studentType === "new"
                ? "New In Invoice"
                : studentType === "another_invoice"
                ? "Another Invoice"
                : studentType === "wait"
                ? "Invoice Wait"
                : ""}
            </h1>
            <div className="pr-6">
              <button
                type="button"
                className="text-white bg-blue-600 hover:bg-blue-700 p-2 
                      focus:ring-4 focus:ring-blue-400 font-medium rounded-lg text-sm text-center cursor-pointer"
                onClick={handleExportTopAchievers}
              >
                Export Top Achievers
              </button>
            </div>
          </div>
          <div className="flex justify-center">
            <div
              className="lg:w-3/5 md:w-3/4 w-full min-h-screen border shadow
              flex flex-col bg-white p-6 rounded-lg"
            >
              <StudentList
                setSearch={(val) => {
                  setSearch(val);
                  setHasSearched(true);
                }}
                students={students}
                search={search}
                loading={loading}
                count={count}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function convertType(studentType) {
  switch (studentType) {
    case "new":
      return "invoice";
    case "another_invoice":
      return "another_invoice";
    case "wait":
      return "invoice_wait";
    default:
      return "invoice";
  }
}
